/**
 * The missions the chat offers: every mission GET /v1/missions returned for
 * the caller except archived ones and the assistant pseudo-missions, with
 * drafts marked as drafts. The sidebar, its live subscriptions and the start
 * page search share this one filter (agion/Agion#2873). It only arranges the
 * server's list; which missions the caller may see is the server's answer.
 */
import type { Mission } from '../types/mission'

type ListedMissionFields = Pick<Mission, 'id' | 'name' | 'title' | 'status' | 'state'>

function missionStatus(mission: ListedMissionFields) {
  return mission.status || mission.state
}

function isAssistantPseudoMission(mission: ListedMissionFields): boolean {
  const name = mission.name || mission.title || ''
  return name.toLowerCase().includes('agion assistant') || mission.id === 'agion-assistants' || mission.id === 'agion-assistant'
}

/** True for a mission the chat lists: not archived and not an assistant pseudo-mission. */
export function isListedMission(mission: ListedMissionFields): boolean {
  return missionStatus(mission) !== 'archived' && !isAssistantPseudoMission(mission)
}

/** True for a draft mission, which the chat lists with a draft marker. */
export function isDraftMission(mission: ListedMissionFields): boolean {
  return missionStatus(mission) === 'draft'
}
